export default __webpack_public_path__ + "static/media/m_four.17fdadbb.png";